const WithPadding = ({ children }) => (
    <div style={{ paddingLeft: '100px', paddingRight: '100px', paddingTop: '80px', paddingBottom: '20px' }}>
        {children}
    </div>
);

export default WithPadding;
